










































































































































































































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { CONTACT_FORM_EMPTY } from '@/modules/contacts/shared/domain/contact.form.empty';
import { PropSync, Watch } from 'vue-property-decorator';
import { ContactFormInterface } from '@/modules/contacts/shared/domain/contact-form.interface';
import { contactRules } from '@/modules/contacts/shared/domain/contact.rules';
import { contacts, user } from '@/modules/shared/shared/store/namespaces';
import {
    CHECK_IF_CONTACT_EXISTS,
    CONTACTS_CREATE_CONTACT,
    CONTACTS_CREATE_USER,
    CONTACTS_FETCH_VIEW,
    CONTACTS_UPDATE_CONTACT,
} from '@/modules/contacts/shared/store/contacts.actions';
import { GET_USER_CONTACT, IS_CONTACT_ADMINISTRATOR } from '@/modules/users/store/user.getters';
import {
    CONTACT_GET_CONTACT_RESOURCES,
    CONTACT_GET_CONTACT_TYPES,
    CONTACT_GET_CONTACT_SCALABILITY_LEVELS,
    CONTACT_GET_FORM_VIEW,
    CONTACT_GET_LAST_ROUTE,
    ContactsGetters,
} from '@/modules/contacts/shared/store/contacts.getters';
import { Resource } from '@/modules/contacts/shared/domain/resource.interface';
import { ContactType } from '@/modules/contacts/shared/domain/contact-type';
import { Contact } from '@/modules/contacts/shared/domain/contact';
import { EventBus } from '@/main';
import { EventBusMessages } from '@/modules/shared/shared/domain/constants/event-bus-messages';
import BaseModal from '@/modules/shared/layouts/components/BaseModal.vue';
import { LOOK_UP_USER } from '@/modules/users/store/user.actions';
import {
    ContactValidation,
    FormView,
    Resources,
    ResultStatus,
} from '@/modules/shared/shared/domain/constants/constants';
import PhoneField from '@/modules/shared/shared/components/PhoneField.vue';
import { ScalabilityLevel } from '../../shared/domain/scalability-level';
import { cloneDeep } from 'lodash';

@Component({
    components: { PhoneField, BaseModal },
})
export default class CreateContactForm extends Vue {
    @PropSync('dataContact', {
        required: false,
        type: Object,
        default: () => {
            return cloneDeep(CONTACT_FORM_EMPTY);
        },
    })
    contact!: ContactFormInterface;

    allowRepeatedCi: boolean = false;

    isContactAdministrator: boolean = false;

    oldEmail: string = '';

    nationalityOptions = ['V', 'E', 'P'];

    $refs!: {
        form: any;
        formPassword: any;
        privilegeConfirmationModal: any;
        primaryPhone: any;
        secondaryPhone: any;
    };

    snackbar: boolean = false;
    snackbarColor: string = 'red';
    snackbarText: string = '';
    displayContactExistsDialog: boolean = false;
    contactExistDialogText: string = '';

    rules = contactRules;

    showPassword: boolean = false;
    showConfirmationPassword: boolean = false;
    showPosition: boolean = true;

    selectedResources: Resource[] = [];

    get passwordRules() {
        const rules = [this.rules.noSpacesAllowed(), this.rules.fieldMinLength(8)];
        if (this.contact.confirmationPassword) {
            const rule = (v: any) =>
                (!!v && this.contact.password == this.contact.confirmationPassword) ||
                'Las contraseñas no coinciden';
            rules.push(rule);
        }
        return rules;
    }

    @Watch('contact.confirmationPassword')
    onPasswordChanged() {
        this.$refs.formPassword.validate();
    }

    @Watch('contact.password')
    onConfirmationPasswordChanged() {
        if (!this.contact.password || this.contact.password.length == 0) {
            this.contact.confirmationPassword = '';
        }
        this.$refs.formPassword.validate();
    }

    closeSnackbar() {
        this.snackbar = false;
        this.snackbarText = '';
    }

    openSnackbar(message: string, color: string) {
        this.snackbarText = message;
        this.snackbarColor = color;
        this.snackbar = true;
    }

    get isUpdating(): boolean {
        return this.FORM_VIEW === FormView.UPDATING || this.isUpdatingWithoutUser;
    }

    get isUpdatingWithoutUser(): boolean {
        return this.FORM_VIEW === FormView.UPDATING_WITHOUT_USER;
    }

    get isCreatingUser(): boolean {
        return this.FORM_VIEW === FormView.CREATING_USER;
    }

    get sendButton(): { text: string; action: Function } {
        if (this.isUpdatingWithoutUser) {
            return {
                action: this.updateContactWithoutUser,
                text: 'ACTUALIZAR CONTACTO',
            };
        } else if (this.isUpdating) {
            return {
                action: this.updateContact,
                text: 'ACTUALIZAR CONTACTO',
            };
        } else if (this.isCreatingUser) {
            return {
                action: this.createUser,
                text: 'CREAR USUARIO',
            };
        }
        return {
            action: this.createContact,
            text: 'CREAR CONTACTO',
        };
    }

    get allSelectedResources() {
        if (this.isContactAdministrator) {
            const r: Resource = {
                id: Resources.PRIVILEGE_ADMINISTRATION.id,
                name: Resources.PRIVILEGE_ADMINISTRATION.name,
                sgcName: '',
            };
            return this.selectedResources.concat([r]);
        }
        return this.selectedResources;
    }

    fillSelectedResources() {
        const contactRoles = this.contact.contactRoles as any;
        try {
            this.selectedResources = this.sgcResources.filter(resource =>
                this.contact.sgcResources.find(r => r.privilege.name === resource.sgcName),
            );
            this.isContactAdministrator = !!contactRoles.role.rolePrivileges.find(
                i => i.privilege.resource.id === Resources.PRIVILEGE_ADMINISTRATION.id,
            );
        } catch (e) {
            this.selectedResources = [];
            this.isContactAdministrator = false;
        }
    }

    async mounted() {
        await this.CONTACTS_FETCH_VIEW(this.USER_CONTACT.customer.id);

        this.showPosition = !(
            this.isUpdating ||
            (this.isCreatingUser && this.contact.position && this.contact.position.length > 0)
        );

        if (this.isUpdating || this.isCreatingUser) {
            if (this.isUpdating && !this.isUpdatingWithoutUser) {
                this.fillSelectedResources();
            } else {
                if (this.sgcResources.length) {
                    this.selectedResources = this.sgcResources;
                }
            }
            this.oldEmail = this.contact.email;
        }

        this.$refs.form.register(this.$refs.primaryPhone);
        this.$refs.form.register(this.$refs.secondaryPhone);
    }

    async isAnExistingContact(): Promise<boolean> {
        const response = await this.CHECK_IF_CONTACT_EXISTS({
            id: this.contact.contactId,
            identification: this.contact.nationality + this.contact.ci,
            customer: { id: this.USER_CONTACT.customer.id },
            email: this.contact.email,
        });

        if (response.hint === ContactValidation.EXISTING_EMAIL) {
            if (this.oldEmail !== this.contact.email) {
                this.openSnackbar(response.message, 'red');
                return true;
            }
        } else if (response.hint === ContactValidation.EXISTING_EMAIL_AND_CI_IN_CUSTOMER) {
            if (this.contact.email !== this.oldEmail) {
                this.openSnackbar(response.message, 'red');
                return true;
            }
            if (!this.allowRepeatedCi) {
                this.contactExistDialogText = response.message;
                this.displayContactExistsDialog = true;
                return true;
            }
        } else if (
            response.hint === ContactValidation.EXISTING_CI_IN_CUSTOMER ||
            response.hint === ContactValidation.EXISTING_CI_IN_ANOTHER_CUSTOMER
        ) {
            if (!this.allowRepeatedCi) {
                this.contactExistDialogText = response.message;
                this.displayContactExistsDialog = true;
                return true;
            }
        } else if (response.hint === ContactValidation.UNDEFINED_ERROR) {
            this.openSnackbar(response.message, 'red');
            return true;
        }
        return false;
    }

    async createContact() {
        EventBus.$emit(EventBusMessages.SHOW_LOADER);

        if (this.$refs.form.validate() && this.$refs.formPassword.validate()) {
            if (!(await this.isAnExistingContact())) {
                const data = await this.CREATE_CONTACT({
                    contact: {
                        ...this.contact,
                        phone: this.$refs.primaryPhone.correctFormatPhone,
                        cellphone: this.$refs.secondaryPhone.correctFormatPhone,
                    },
                    userContact: this.USER_CONTACT,
                    selectedResources: this.allSelectedResources,
                });

                this.endRequest(data);
            }
        }

        EventBus.$emit(EventBusMessages.HIDE_LOADER);
    }

    async updateContact() {
        EventBus.$emit(EventBusMessages.SHOW_LOADER);

        if (this.$refs.form.validate()) {
            if (!(await this.isAnExistingContact())) {
                const data = await this.UPDATE_CONTACT({
                    contact: {
                        ...this.contact,
                        phone: this.$refs.primaryPhone.correctFormatPhone,
                        cellphone: this.$refs.secondaryPhone.correctFormatPhone,
                    },
                    userContact: this.USER_CONTACT,
                    selectedResources: this.allSelectedResources,
                    withUser: true,
                });

                this.endRequest(data);
            }
        }

        EventBus.$emit(EventBusMessages.HIDE_LOADER);
    }

    async createUser() {
        EventBus.$emit(EventBusMessages.SHOW_LOADER);

        if (this.$refs.form.validate() && this.$refs.formPassword.validate()) {
            if (!(await this.isAnExistingContact())) {
                const data = await this.CREATE_USER({
                    contact: {
                        ...this.contact,
                        phone: this.$refs.primaryPhone.correctFormatPhone,
                        cellphone: this.$refs.secondaryPhone.correctFormatPhone,
                    },
                    userContact: this.USER_CONTACT,
                    selectedResources: this.allSelectedResources,
                });

                this.endRequest(data);
            } else {
                this.displayContactExistsDialog = true;
            }
        }

        EventBus.$emit(EventBusMessages.HIDE_LOADER);
    }

    async updateContactWithoutUser() {
        EventBus.$emit(EventBusMessages.SHOW_LOADER);

        if (this.$refs.form.validate()) {
            if (!(await this.isAnExistingContact())) {
                const data = await this.UPDATE_CONTACT({
                    contact: {
                        ...this.contact,
                        phone: this.$refs.primaryPhone.correctFormatPhone,
                        cellphone: this.$refs.secondaryPhone.correctFormatPhone,
                    },
                    userContact: this.USER_CONTACT,
                    selectedResources: this.selectedResources,
                    withUser: false,
                });

                this.endRequest(data);
            }
        }

        EventBus.$emit(EventBusMessages.HIDE_LOADER);
    }

    endRequest(data: { status: string; message: string }) {
        this.snackbarText = data.message;
        if (data.status === ResultStatus.ERROR) {
            this.snackbarColor = 'red';
            this.snackbar = true;
        } else {
            this.contact = CONTACT_FORM_EMPTY;
            EventBus.$emit(EventBusMessages.HIDE_LOADER);
            this.$router.push({
                name: this.LAST_ROUTE,
                params: { status: data.status, message: data.message },
            });
        }
    }

    @Watch('selectedResources')
    onSelectedResourcesChanged(val: Resource[], oldVal: Resource[]) {
        if (
            val.find(i => i.sgcName === 'Movilización de Equipos') &&
            !val.find(i => i.sgcName === 'Solicitud de Permisos de Trabajo (PDT)')
        ) {
            this.selectedResources.push(
                this.RESOURCES.find(i => i.sgcName === 'Solicitud de Permisos de Trabajo (PDT)')!,
            );
        }
    }

    @contacts.Getter(ContactsGetters.GET_AVAILABLE_RESOURCES)
    sgcResources!: Resource[];

    @contacts.Action(CONTACTS_FETCH_VIEW) CONTACTS_FETCH_VIEW!: (
        customerId: number,
    ) => Promise<boolean>;
    @contacts.Getter(CONTACT_GET_FORM_VIEW) FORM_VIEW!: string;
    @contacts.Getter(CONTACT_GET_CONTACT_RESOURCES) RESOURCES!: Resource[];
    @contacts.Getter(CONTACT_GET_CONTACT_TYPES) CONTACT_TYPES!: ContactType[];
    @contacts.Getter(CONTACT_GET_CONTACT_SCALABILITY_LEVELS)
    SCALABILITY_LEVELS!: ScalabilityLevel[];
    @contacts.Action(CONTACTS_CREATE_CONTACT) CREATE_CONTACT!: (params: {
        contact: ContactFormInterface;
        userContact: Contact;
        selectedResources: Resource[];
    }) => Promise<{ status: string; message: string }>;
    @contacts.Action(CONTACTS_UPDATE_CONTACT) UPDATE_CONTACT!: (params: {
        contact: ContactFormInterface;
        userContact: Contact;
        selectedResources: Resource[];
        withUser: boolean;
    }) => Promise<{ status: string; message: string }>;
    @contacts.Action(CONTACTS_CREATE_USER) CREATE_USER!: (params: {
        contact: ContactFormInterface;
        userContact: Contact;
        selectedResources: Resource[];
    }) => Promise<{ status: string; message: string }>;
    @contacts.Action(CHECK_IF_CONTACT_EXISTS) CHECK_IF_CONTACT_EXISTS!: (params: {
        id: number;
        identification: string;
        customer: { id: number };
        email: string;
    }) => Promise<{ status: number; message: string; hint: string }>;

    @user.Getter(GET_USER_CONTACT) USER_CONTACT!: Contact;
    @user.Action(LOOK_UP_USER) USER_EXIST!: (email: string) => Promise<boolean>;
    @user.Getter(IS_CONTACT_ADMINISTRATOR) IS_CONTACT_ADMINISTRATOR!: boolean;
    @contacts.Getter(CONTACT_GET_LAST_ROUTE) LAST_ROUTE!: string;
}
